<template>
  <v-container grid-list-md>
    <v-layout justify-center>
      <v-flex xs12 lg8>
        <v-form v-model="valid" ref="form">
          <v-card>
            <v-card-text>
              <v-layout row>
                <v-flex xs12>
                  <v-text-field
                    prepend-inner-icon="mdi-format-title"
                    v-model="atividade.titulo"
                    label="Título"
                    required
                    :rules="rules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="atividade.disciplina_id"
                    :disabled="disciplinas.length < 1"
                    :items="disciplinas"
                    label="Disciplina"
                    item-text="nome"
                    item-value="id"
                    required
                    :rules="rules"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    v-model="atividade.idTurmas"
                    :disabled="turmas.length < 1 || atividade.id != null"
                    :items="turmas"
                    label="Turma"
                    :item-text="
                      turma =>
                        `${turma.serie.nome} - ${turma.nome} - ${turma.serie.nivel.nome}`
                    "
                    multiple
                    chips
                    item-value="id"
                    hint="Seleciona a(s) Turma(s)"
                    persistent-hint
                    required
                    :rules="rules"
                  ></v-select>
                </v-flex>
                <v-flex xs12 lg12>
                  <header>Notificar para</header>
                  <v-radio-group
                    row
                    v-model="atividade.enviar"
                    required
                    :rules="rules"
                  >
                    <v-radio
                      v-for="(option, index) in radioOptions"
                      :key="option"
                      color="primary"
                      :label="option"
                      :value="String(index)"
                    />
                  </v-radio-group>
                </v-flex>
                <v-flex xs12>
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :value="
                          atividade.data &&
                            moment(atividade.data).format('DD/MM/YYYY')
                        "
                        label="Data"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        clearable
                        v-on="on"
                        required
                        :rules="rules"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="atividade.data"
                      no-title
                      @input="menu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex xs12>
                  <v-row>
                    <v-col>
                      <p class="title primary--text ma-0">Conteúdo</p>
                    </v-col>
                    <v-col class="text-right">
                      <v-switch
                        v-model="atividade.is_licao_casa"
                        label="Lição de casa"
                        false-value="N"
                        true-value="S"
                        color="primary"
                        class="ma-0"
                      ></v-switch>
                    </v-col>
                  </v-row>
                  <wysiwyg v-model="atividade.conteudo" />
                  <div class="text-right my-2">
                    <v-btn color="primary" @click="$refs.upload.click()">
                      <v-icon class="mr-3">mdi-paperclip</v-icon>Anexar Arquivo
                    </v-btn>
                    <input
                      type="file"
                      ref="upload"
                      multiple
                      v-show="false"
                      @change="handleUpload"
                    />
                  </div>
                </v-flex>
              </v-layout>
              <template v-if="atividade.is_licao_casa == 'S'">
                <v-divider />
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-row>
                      <v-col>
                        <p class="title primary--text ma-0">Lição de casa</p>
                      </v-col>
                    </v-row>
                    <wysiwyg v-model="atividade.licao_casa" />
                  </v-flex>
                </v-layout>
              </template>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" dark @click="submit">Salvar</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { Atividade, Disciplina, Turma } from '../../service'

export default {
  data() {
    return {
      escola: localStorage.getItem('escola')
        ? localStorage.getItem('escola')
        : '',
      atividade: {
        is_licao_casa: 'N',
        funcao_id: 1,
        status: 'C',
        idTurmas: null,
        licao_casa: ''
      },
      turmas: [],
      menu: false,
      disciplinas: [],
      radioOptions: ['Aluno', 'Responsavel', 'Ambos'],
      files: [],
      valid: false,
      rules: [v => !!v || 'Campo requerido.']
    }
  },
  async created() {
    this.turmas = await Turma.findAll({ escola: this.escola })
    this.disciplinas = await Disciplina.findAll({ escola: this.escola })

    if (this.$route.params.id) {
      const atividade = await Atividade.findById(this.$route.params.id, {
        escola: this.escola
      })
      this.files = await Atividade.getAnexos(atividade.id, this.escola)
      atividade.disciplina_id = atividade.disciplina.id
      atividade.idTurmas = atividade.turma.map(t => t.id)
      this.atividade = atividade
    }
  },
  methods: {
    async submit() {
      if (await this.$refs.form.validate()) {
        let ativ = {}
        if (!this.atividade.licao_casa) {
          ativ = { ...this.atividade, is_licao_casa: 'N' }
        } else {
          ativ = this.atividade
        }
        const atividade = await Atividade.save(ativ, {
          escola: this.escola
        })
        await Atividade.setAnexos(atividade.id, this.files, this.escola)
        this.$router.push(`/atividades/${atividade.id}`)
      }
    },
    handleUpload() {
      this.files = this.$refs.upload.files
    }
  }
}
</script>

<style>
.ck-editor__editable {
  height: 200px !important;
}
</style>
